var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":""}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.items),function(item){return _c('el-option',{key:item.codeValue,attrs:{"value":item.codeValue,"label":item.codeText}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }